import {ORDER_CREATED, ORDER_CREATION_FAILED, RECIPIENT_BY_PHONE_FETCHED, POINTS_FETCHED, TEAMS_FOR_ORDERCREATION_FETCHED} from '../constants/actionTypes';
import objectAssign from 'object-assign';
import initialState from './initialState';


export default function orderCreationReducer(state = initialState.orderCreationState, action) {

  switch (action.type) {
    case POINTS_FETCHED:
      return objectAssign({}, state, {pickUpPoints: action.pickUpPoints});

    case ORDER_CREATED:
      return objectAssign({}, state, {orderCreated: action.orderCreated, createdStuff: action.createdStuff});

    case TEAMS_FOR_ORDERCREATION_FETCHED:
      return objectAssign({}, state, {teams: action.teams});

    case ORDER_CREATION_FAILED:
      return state;

    case RECIPIENT_BY_PHONE_FETCHED:
      return objectAssign({}, state, { recipient: action.fetched_recipients.pop()});
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/orderCreationReducer.js